import { render, staticRenderFns } from "./contribute_modal.vue?vue&type=template&id=287dd146&scoped=true&"
import script from "./contribute_modal.vue?vue&type=script&lang=js&"
export * from "./contribute_modal.vue?vue&type=script&lang=js&"
import style0 from "./contribute_modal.vue?vue&type=style&index=0&id=287dd146&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "287dd146",
  null
  
)

export default component.exports